import { useEffect, useState, useMemo, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import DashboardSplitPane from '../../../../../core/Dashboard/DashboardSplitPane'
import { EmployeeLeftPanel } from './EmployeeLeftPanel'
import { EmployeeRightPanel } from './EmployeeRightPanel'
import { useTileDashboard } from '../../../dashboard/Dashboard'
import { getAutoUpdateFilters } from '../../../helpers'
import { convertArrayToObject } from '../../../../../../utils/functions/helpers'

import { useTeams } from 'components/pages/dis/hooks/useTeams'
import useProject from 'components/pages/dis/hooks/useProject'
import { isEmpty } from 'lodash'

export function EmployeeSummaryComponent(props) {
	const {
		tile,
		settings,
		setTitleSuffix,
		dashboardKeyList,
		passedIdValue: parentPassedIdValue,
		modalDashboardSetting: parentModalDashboardSetting,
	} = props
	const { customemizedGroupName, linkedFields } = useMemo(() => settings || {}, [settings])
	const environment = useSelector((state) => state.environment)

	const { loadingDevices } = useTeams()
	const { projectLoading } = useProject({ enabled: true })

	const { selectedFields } = useTileDashboard()
	const { filterConfigs } = useMemo(
		() => getAutoUpdateFilters(linkedFields, selectedFields, dashboardKeyList),
		[linkedFields, selectedFields]
	)

	const [selectedMobile, setSelectedMobile] = useState(null)

	const filterWithoutId = useMemo(
		() =>
			filterConfigs.map((item) => {
				const { id, ...rest } = item
				return rest
			}),
		[filterConfigs]
	)

	const linkedMobileNumber = useMemo(() => {
		const { Mobile_number: mobileNumber } = convertArrayToObject(filterWithoutId)
		return mobileNumber || ''
	}, [filterWithoutId])

	useEffect(() => {
		if (environment?.devices instanceof Array === false || !linkedMobileNumber) {
			return
		}

		const device = environment?.devices?.find((device) => device.number === linkedMobileNumber)

		setSelectedMobile(device || null)
	}, [environment?.devices, linkedMobileNumber])

	useEffect(() => {
		let suffix = '- '
		if (!isEmpty(selectedMobile)) {
			suffix += selectedMobile?.name || selectedMobile?.number
		} else {
			suffix += 'All'
		}
		setTitleSuffix(suffix)
	}, [selectedMobile])

	return (
		// <DashboardSplitPane
		// 	sidePanel={
		// 		<EmployeeLeftPanel
		// 			customemizedGroupName={customemizedGroupName}
		// 			selectedMobile={selectedMobile}
		// 			setSelectedMobile={setSelectedMobile}
		// 		/>
		// 	}
		// 	mainContent={

		// 	}
		// />
		<EmployeeRightPanel
			tile={tile}
			selectedMobile={selectedMobile}
			settings={settings}
			initLoading={loadingDevices || projectLoading}
			parentPassedIdValue={parentPassedIdValue}
			parentModalDashboardSetting={parentModalDashboardSetting}
			linkedMobileNumber={linkedMobileNumber}
		/>
	)
}
